import React, { useCallback } from 'react';
import { toReal } from '../../utils';

function CourseInformationTransaction({ transaction, currentVoucher }) {
  const calcAmounVoucher = useCallback(() => {
    if (currentVoucher) {
      const {amount, percent} = currentVoucher;
      if(Number(amount) > 0) {
        const fixedAmount = Number(transaction.value) - Number(amount);
        return <>
        <p style={{color: 'green'}}>Desconto ({toReal(Number(amount))})</p>
        <p style={{fontWeight: '600'}}>Novo valor: {toReal(fixedAmount)}</p>
        </>
      } else if(Number(percent) > 0) {
        const fixedAmount = Number(transaction.value) - ( Number(transaction.value) * ( Number(percent) / 100) );
        return <>
        <p style={{color: 'green'}}>Desconto ({Number(percent)}%)</p>
        <p style={{fontWeight: '600'}}>Novo Valor: {toReal(fixedAmount)}</p>
        </>
      }
    }

    return null;
  }, [currentVoucher])

  return (
    <div className="courseInfoContainer">
      <div className="courseInfoGroup">
        <strong>Turma</strong>
        <p>{transaction.inscription.course_class.name}</p>
      </div>
      <div className="courseInfoGroup">
        <strong>Valor da Inscrição</strong>
        <p>R$ {transaction.inscription.value}</p>
      </div>
      <div className="courseInfoGroup">
        <strong>Valor à pagar</strong>
        <p style={currentVoucher ? {
          textDecoration: 'line-through',
          fontStyle: 'italic',
          color: '#e91e63',
          fontWeight: '600'
        } : {fontWeight: '600'}}>R$ {transaction.value}</p>
        {calcAmounVoucher()}
      </div>
    </div>
  );
}

export default CourseInformationTransaction;